// =============================================================================
// Estúdio de Criação — início: a gerente escolhe a campanha em que vai trabalhar.
// Cada cartão mostra o que já existe de cada peça (identidade, stories, pôster,
// catálogo) e leva direto pra aba dela. Ver utils/estudio.js.
// =============================================================================
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../contexts/AuthContext';
import Tela, { Rodape } from '../components/estudio/Tela';
import { linkEstudio } from '../utils/estudio';

const dia = (d) => (d ? String(d).slice(0, 10).split('-').reverse().slice(0, 2).join('/') : '');
const semAcento = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export default function Estudio() {
  const navigate = useNavigate();
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState(null);
  const [todas, setTodas] = useState(false);
  const [busca, setBusca] = useState('');

  useEffect(() => {
    let vivo = true;
    setLista(null);
    axios.get(`${API}/catalogo/estudio/campanhas${todas ? '?todas=1' : ''}`)
      .then(r => { if (vivo) setLista(r.data || []); })
      .catch(e => { if (vivo) { setErro(e.response?.data?.error || 'Não consegui carregar as campanhas.'); setLista([]); } });
    return () => { vivo = false; };
  }, [todas]);

  const filtradas = useMemo(() => {
    const t = semAcento(busca.trim());
    return (lista || []).filter(c => !t || semAcento(c.nome).includes(t));
  }, [lista, busca]);

  const abrir = (id, aba) => navigate(linkEstudio(id, aba));
  const peca = (c, aba, icone, rotulo, n, tem) => (
    <button type="button" className={`peca ${tem ? 'tem' : ''}`} title={`Abrir ${rotulo.toLowerCase()}`}
      onClick={e => { e.stopPropagation(); abrir(c.id, aba); }}>
      <i className={`bi bi-${icone}`}></i>{rotulo}{n != null && <b>{n}</b>}
    </button>
  );

  return (
    <Tela titulo="Estúdio de Criação" sub="Escolha a campanha pra criar os stories, os pôsteres e o catálogo"
      acoes={<>
        <input className="form-control form-control-sm" style={{ width: 240 }} placeholder="Buscar campanha..."
          value={busca} onChange={e => setBusca(e.target.value)} autoFocus />
        <label className="d-flex align-items-center gap-1 text-muted" style={{ whiteSpace: 'nowrap' }}>
          <input type="checkbox" checked={todas} onChange={e => setTodas(e.target.checked)} />encerradas há mais tempo
        </label>
      </>}>
      {!lista && <div className="text-muted p-3"><span className="spinner-border spinner-border-sm me-2"></span>Carregando as campanhas...</div>}
      {lista && erro && <div className="alert alert-danger py-2">{erro}</div>}
      {lista && !erro && filtradas.length === 0 && (
        <div className="text-muted p-4 text-center">{busca ? 'Nenhuma campanha com esse nome.' : 'Nenhuma campanha ainda.'}</div>
      )}
      <div className="camps-e" style={{ flex: '1 1 0', minHeight: 0 }}>
        {filtradas.map(c => {
          const temIdentidade = c.artes.length > 0;
          return (
            <div key={c.id} className="camp-e" onClick={() => abrir(c.id)} role="button" tabIndex={0}
              onKeyDown={e => { if (e.key === 'Enter') abrir(c.id); }}>
              <div className="d-flex justify-content-between align-items-start gap-2">
                <div className="nome">{c.nome}</div>
                <span className={`badge-${c.status || 'rascunho'}`} style={{ whiteSpace: 'nowrap' }}>{c.status}</span>
              </div>
              <div className="datas">
                {c.data_inicio ? `${dia(c.data_inicio)} a ${dia(c.data_fim)}` : 'Sem período'} · {c.aprovados} produto{c.aprovados === 1 ? '' : 's'} aprovado{c.aprovados === 1 ? '' : 's'}
              </div>
              <div className="pecas">
                <button type="button" className={`peca ${temIdentidade ? 'tem' : 'falta'}`}
                  title={temIdentidade ? 'A campanha tem arte própria' : 'Ainda sem arte da campanha: suba o logo e o fundo'}
                  onClick={e => { e.stopPropagation(); abrir(c.id, 'identidade'); }}>
                  <i className={`bi bi-${temIdentidade ? 'check2' : 'palette'}`}></i>Identidade
                </button>
                {peca(c, 'stories', 'instagram', 'Stories ', c.stories, c.stories > 0)}
                {peca(c, 'poster', 'file-earmark-image', 'Pôster ', c.posters, c.posters > 0)}
                {peca(c, 'catalogo', 'journal-richtext', 'Catálogo ', c.catalogo, c.catalogo > 0)}
              </div>
            </div>
          );
        })}
      </div>
      <Rodape atalhos={[['Enter', 'abre a campanha']]}>
        {lista ? `${filtradas.length} campanha(s)` : ''} · verde = já tem montagem salva · laranja = falta a identidade
      </Rodape>
    </Tela>
  );
}
